import { Box, Stack, useMediaQuery } from '@mui/material';
import
{
  Container,
  MainContainer,
  BannerContainer,
} from './MainWrapper.styles';
import { adminExpandedRoutes } from '../../../options/navLinks';
import Banner from '../../Alerts/Banner/Banner';
import MainNavMenu from '../../NavMenus/MainNavMenu/MainNavMenu';
import MobileNavMenu from '../../NavMenus/MobileNavMenu/MobileNavMenu';
import AdminNavMenu from '../../NavMenus/AdminNavMenu/AdminNavMenu';
import PageSpinner from '../../Loading/PageSpinner/PageSpinner';
import { getManageClubId, getManageProfile, unsetManage } from '../../../utils/helpers/clubHelper';
import { useEffect, useState } from 'react';
import ManagedModeBanner from '../../Alerts/ManagedModeBanner/ManagedModeBanner';

const MainWrapper = ({ children, error, errorData, apiMessage, handleBannerClose, activeRoute, clubLogo, disableIndex, dataLoading, hasEliteLicence, hasRezzilPlayerLicence, licences }) =>
{
  const matches = useMediaQuery((theme) => theme.breakpoints.up('lg'));


  const [managedClubId, setManagedClubId] = useState(true);
  const [managedProfile, setManagedProfile] = useState({});
  useEffect(async () =>
  {
    const manageClubId = await getManageClubId();
    const profile = await getManageProfile();
    if (manageClubId !== managedClubId)
    {
      setManagedClubId(manageClubId);
      setManagedProfile(profile);
    }

  })

  return (
    <>
      {
        matches &&
        <>
          <MainNavMenu
            licences={licences}
            activeRoute={activeRoute}
            clubLogo={clubLogo}
            disableIndex={disableIndex}
            hasEliteLicence={hasEliteLicence}
            hasRezzilPlayerLicence={hasRezzilPlayerLicence}
          />
          {
            adminExpandedRoutes.includes(activeRoute) &&
            <AdminNavMenu
              activeRoute={activeRoute}
              licences={licences}
            />
          }
        </>
      }
      {
        !matches &&
        <MobileNavMenu
          activeRoute={activeRoute}
          clubLogo={clubLogo}
          disableIndex={disableIndex}
          hasEliteLicence={hasEliteLicence}
          hasRezzilPlayerLicence={hasRezzilPlayerLicence}
          licences={licences}
        />
      }
      <Container
        admin={adminExpandedRoutes.includes(activeRoute) ? 'true' : undefined}
      >  {managedClubId && managedProfile &&
        <Stack spacing={0}
        >

          {/*           <Box>
            You are currently managing: {managedProfile.name}
          </Box> */}

          <ManagedModeBanner
            onClose={handleBannerClose}
            open={managedClubId}
            text={`You are currently managing: ${managedProfile.name}`}
            isSuccess={false}
            isFixed
            showBtn={true}
            btnText={'stop managing'}
            onClick={() =>
            {
              unsetManage();
              window.location.reload();
            }}
          />
        </Stack>
        }
        <MainContainer>

          {apiMessage &&
            <BannerContainer
              admin={adminExpandedRoutes.includes(activeRoute) ? 'true' : undefined}
            >
              <Banner
                onClose={handleBannerClose}
                open={!!apiMessage}
                text={apiMessage}
                isSuccess={!error}
                isFixed
                showBtn={errorData?.showBtn}
                btnText={errorData?.btnText}
                onClick={errorData?.onClick}
                showClose
              />
            </BannerContainer>
          }
          {dataLoading ? <PageSpinner /> : children}

        </MainContainer>
      </Container>
    </>
  );
};

export default MainWrapper;
